import Link from 'next/link';
import useLocale from 'next-translate/useTranslation';
import React from 'react';

const VideoFaq = () => {
  const { t } = useLocale('ai-videos');

  return (
    <section id='faq' className='bg-gray-50 dark:bg-slate-900 py-24'>
      <div className='container mx-auto flex flex-col justify-center px-4 md:px-8'>
        <h2 className='mb-12 text-center text-3xl font-extrabold leading-8 tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
          {t('Frequently Asked Questions')}
        </h2>
        <div className='grid gap-10 sm:p-3 md:grid-cols-2 md:gap-8 lg:px-12 xl:px-32'>
          <div>
            <h3 className='font-semibold text-gray-900 dark:text-slate-200'>
              {t('How long does it take to generate a video?')}
            </h3>
            <p className='mt-1 text-gray-500 dark:text-slate-400'>
              {t(
                'Most videos are generated within minutes. Complex or longer videos may take slightly longer depending on the server load.',
              )}
            </p>
          </div>
          <div>
            <h3 className='font-semibold text-gray-900 dark:text-slate-200'>
              {t('Can I use the videos for commercial purposes?')}
            </h3>
            <p className='mt-1 text-gray-500 dark:text-slate-400'>
              {t(
                'Yes, if you are on a paid plan, you own the commercial rights to all videos you generate.',
              )}
            </p>
          </div>
          <div>
            <h3 className='font-semibold text-gray-900 dark:text-slate-200'>
              {t('What formats are the videos in?')}
            </h3>
            <p className='mt-1 text-gray-500 dark:text-slate-400'>
              {t(
                'Videos are typically generated in MP4 format, which is compatible with all major social media platforms and video players.',
              )}
            </p>
          </div>
          <div>
            <h3 className='font-semibold text-gray-900 dark:text-slate-200'>
              {t('Do I need credits to generate videos?')}
            </h3>
            <p className='mt-1 text-gray-500 dark:text-slate-400'>
              {t(
                'Yes, video generation consumes credits. The amount depends on the video length and model used. You can see the cost before generating.',
              )}
            </p>
          </div>
          <div>
            <h3 className='font-semibold text-gray-900 dark:text-slate-200'>
              {t('Can I upload my own images?')}
            </h3>
            <p className='mt-1 text-gray-500 dark:text-slate-400'>
              {t(
                'Absolutely! You can upload any image to animate it or turn it into a talking avatar.',
              )}
            </p>
          </div>
          <div>
            <h3 className='font-semibold text-gray-900 dark:text-slate-200'>
              {t('Is there a limit to how many videos I can create?')}
            </h3>
            <p className='mt-1 text-gray-500 dark:text-slate-400'>
              {t(
                'Your limit depends on your credit balance. You can upgrade your plan or purchase add-on packs if you need more credits.',
              )}
            </p>
          </div>
        </div>
        <div className='mt-10 text-center'>
          <p className='text-sm font-medium text-gray-500 dark:text-slate-400'>
            {t('Still have questions?')}{' '}
            <Link
              href='/contact'
              className='text-purple-600 hover:text-purple-500 dark:text-purple-400'
            >
              {t('Contact Support')}
            </Link>
          </p>
        </div>
      </div>
    </section>
  );
};

export default VideoFaq;
